import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-8 pb-10 sm:pt-12 sm:pb-16 items-center justify-center overflow-hidden bg-bg-main" data-id="element-116">
      {/* Brand */}
      <span className="relative inline-block font-serif font-black text-lg sm:text-2xl tracking-tight text-primary mb-3 sm:mb-4" data-id="element-117">
        EPS<span className="text-text-main" data-id="element-118"> PRÊT-À-L'EMPLOI</span>
      </span>

      {/* Main headline */}
      <h1 className="relative font-serif font-black max-w-4xl text-[30px] leading-[1.12] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-3 sm:mb-5 tracking-tight text-text-main" data-id="element-119">
        Organisez une année complète d'EPS en seulement{' '}
        <span className="text-primary italic font-serif" data-id="element-120">5 minutes</span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-sm sm:text-lg font-medium leading-relaxed mb-5 sm:mb-7 max-w-2xl mx-auto text-text-sec" data-id="element-121">
        Plus de 3 000 enseignants en France ont arrêté d'improviser. Arrivez au
        gymnase avec tout le matériel prêt pour enseigner, motiver et faire
        progresser vos élèves.
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[380px] sm:max-w-[620px] md:max-w-[740px] mx-auto mb-6 sm:mb-8" data-id="element-122">
        <img src="https://cdn.magicpatterns.com/uploads/dGqWc1JDjicZkQa1dbKAEt/aebc0a9b-0c0f-412f-ae19-d5eeca417852-Photoroom.webp" alt="EPS PRÊT-À-L'EMPLOI — Pack numérique avec 12 volumes pour les professeurs d'EPS" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(22,195,74,0.14)]" width={1080} height={680} fetchPriority="high" loading="eager" decoding="async" data-id="element-123" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-bold text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-flex items-center justify-center gap-2 mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-primary hover:bg-primary-hover shadow-[0_10px_30px_-10px_rgba(22,195,74,0.5)]" data-id="element-124">
        <span aria-hidden="true" data-id="element-125">🚀</span>
        JE VEUX LE PACK EPS PRÊT-À-L'EMPLOI
      </a>

      {/* Trust badges */}
      <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-x-4 gap-y-2 flex-wrap" data-id="element-126">
        <span className="flex items-center gap-1" data-id="element-127">
          <span aria-hidden="true" data-id="element-128">🔒</span> Paiement sécurisé
        </span>
        <span className="flex items-center gap-1" data-id="element-129">
          <span aria-hidden="true" data-id="element-130">⚡</span> Accès immédiat
        </span>
        <span className="flex items-center gap-1" data-id="element-131">
          <span aria-hidden="true" data-id="element-132">🛡️</span> Garantie 7 jours
        </span>
      </p>
    </section>;
}